export const GRID_COLS = 32;
export const GRID_ROWS = 24;
export const CELL_SIZE = 22;
export const CANVAS_WIDTH = GRID_COLS * CELL_SIZE;   // 704
export const CANVAS_HEIGHT = GRID_ROWS * CELL_SIZE;  // 528

export const SPEEDS = {
    SLOW:   { label: 'Slow',   ms: 350 },
    NORMAL: { label: 'Normal', ms: 250 },
    FAST:   { label: 'Fast',   ms: 150 },
} as const;

export type SpeedKey = keyof typeof SPEEDS;

export const COLORS = {
    BG:           '#0d1117',
    GRID:         '#161b22',
    SNAKE_HEAD:   '#83cee4',
    SNAKE_BODY:   '#0e7490',
    SNAKE_BORDER: '#22d3ee',
    FOOD:         '#22c55e',
    FOOD_GLOW:    'rgba(34, 197, 94, 0.5)',
    TEXT_PRIMARY: '#f9fafb',
    TEXT_ACCENT:  '#83cee4',
    TEXT_DIM:     '#4b5563',
    OVERLAY:      'rgba(13, 17, 23, 0.82)',
};

export const INITIAL_SNAKE = [
    { x: 6, y: 10 },
    { x: 5, y: 10 },
    { x: 4, y: 10 },
];

export const INITIAL_DIRECTION = { x: 1, y: 0 };

export const HIGH_SCORE_KEY = 'docucr_snake_high_score';
export const SPEED_KEY      = 'docucr_snake_speed';
